var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h5',[_vm._v("Series "+_vm._s(_vm.model.series_name))]),_c('new-criteria-table',{attrs:{"decisions":_vm.model.decisions}}),_c('VisualComponent',{attrs:{"model":_vm.model.content}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }